const normalizePhone = (phone) => phone.replace(/[()\s]/g, '');

const formatPhone = (phone) => {
  const normalized = normalizePhone(phone);
  return `(${normalized.slice(2, 5)}) ${normalized.slice(5, 8)}-${normalized.slice(8, 12)}`;
};

// eslint-disable-next-line import/prefer-default-export
export const standardizePhone = (phone) => {
  if (!phone) {
    return null;
  }

  return {
    normalized: normalizePhone(phone),
    formatted: formatPhone(phone),
  };
};
